import { EMPTY_STRING, SIZE_IN_PIXELS } from '@common/constants';
import { isNumber } from 'lodash';

export const getBlockHeightByChildrenElements = ({ countChilds, childHeight = 75 }: { countChilds: number; childHeight?: number }) => {
  if (!isNumber(countChilds) || !isNumber(childHeight)) return EMPTY_STRING;
  return countChilds * childHeight + SIZE_IN_PIXELS;
};
